import React from 'react';
export function FooterSection() {
  return <footer className="bg-[#0B1F17] py-6 px-3 text-center border-t-2 border-[#D4A843]" data-id="element-50">
      <div className="max-w-4xl mx-auto" data-id="element-51">
        <p className="font-black text-white mb-2 text-sm md:text-base uppercase tracking-widest" data-id="element-52">
          🌲 KIT COMPLETO PRODUCCIÓN FORESTAL LISTO
        </p>
        <p className="text-[#BFC9C5] font-bold text-[10px] md:text-xs mb-3 uppercase" data-id="element-53">
          © 2026 Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-4 text-[9px] md:text-[10px] font-bold text-[#74C69D] uppercase tracking-wider" data-id="element-54">
          <span className="cursor-pointer hover:text-[#D4A843] transition-colors" data-id="element-55">
            Términos y Condiciones
          </span>
          <span className="cursor-pointer hover:text-[#D4A843] transition-colors" data-id="element-56">
            Políticas de Privacidad
          </span>
        </div>
      </div>
    </footer>;
}